export default {
  validate: (value, { minValue, maxValue }) => ({
    required: true,
    valid: /^-?[0-9]+$/.test(value) && Number(minValue) <= Number(value) && Number(value) <= Number(maxValue),
  }),
  params: ['minValue', 'maxValue'],
  message: (fieldName, { _value_: v, minValue, maxValue }) => {
    if (!v) return 'Please enter how much were you fined.';
    if (!/^-?[0-9]+$/.test(v)) return 'Please only enter numbers e.g. 500.';
    if (Number(v) < Number(minValue)) return `The how much were you fined value must be greater than ${minValue}.`;
    if (Number(v) > Number(maxValue)) return `The how much were you fined value must be between ${minValue} and ${maxValue}.`;
    return 'Please enter how much were you fined.';
  },
  computesRequired: true,
};
